import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

// Confirmation shown before a seller soft-deletes (cancels) a listing. The copy
// is taken verbatim from the product spec and warns that deletion is permanent.
function DeleteListingConfirmationDialog (props) {
  const { open, onCancel, onConfirm, errorMessage } = props

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby='delete-listing-dialog-title'>
      <DialogTitle id='delete-listing-dialog-title'>
        Are you sure you want to delete this listing?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deleting it will remove it from your dashboard permanently. You won&apos;t be able to re-list it.
        </DialogContentText>
        <DialogContentText>
          If there&apos;s a chance you&apos;ll want to re-list it, select &ldquo;Mark as Sold&rdquo; instead.
        </DialogContentText>
        {errorMessage
          ? <DialogContentText style={{ color: '#C0392B' }} role='alert'>{errorMessage}</DialogContentText>
          : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} classes={{ root: 'cancel-delete-listing' }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} classes={{ root: 'confirm-delete-listing' }} style={{ color: '#C0392B', fontWeight: 'bold' }}>
          Delete listing
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeleteListingConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
}

export default DeleteListingConfirmationDialog
